<template>
  <v-main>
    <v-container fluid>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-title>
              <h3 class="font-weight-bold">Job Applications</h3>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="6">
                  <v-text-field
                    solo
                    rounded
                    v-model="filter.search_keyword"
                    label="Search by name, email, phone, city or position ..."
                    color="#e60040"
                    hide-details="auto"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    @click:clear="
                      (filter.search_keyword = null), (page = 1), getData()
                    "
                    @keydown.enter="(page = 1), getData()"
                  >
                  </v-text-field>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row>
        <v-col md="12">
          <v-card elevation="6" rounded="xxl">
            <v-card-text>
              <section v-if="isLoading" style="height: 575px">
                <v-progress-linear
                  indeterminate
                  color="primary"
                ></v-progress-linear>
              </section>
              <v-simple-table
                v-else
                fixed-header
                height="575"
                class="striped-table"
              >
                <template v-slot:default>
                  <thead>
                    <tr>
                      <th class="text-left sr_no">Sr No</th>
                      <th class="text-left">Full Name</th>
                      <th class="text-left">Email</th>
                      <th class="text-left">Phone</th>
                      <th class="text-left">City</th>
                      <th class="text-left">Position</th>
                      <th class="text-left">Experience</th>
                      <th class="text-left">Message</th>
                      <th class="text-left">Resume</th>
                      <th class="text-left">Received On</th>
                    </tr>
                  </thead>
                  <tbody v-if="career_applications.length != 0">
                    <tr
                      v-for="(career_application, i) in career_applications"
                      :key="`career_application_${i}`"
                      :class="{
                        'table-row-even': i % 2 === 0,
                        'table-row-odd': i % 2 !== 0,
                        'table-row-last': career_applications.length - 1 == i,
                      }"
                    >
                      <td style="min-width: 85px">
                        {{ serialNoStarting + i + 1 }}
                      </td>
                      <td>{{ career_application.fullname || "" }}</td>
                      <td>
                        <a
                          v-if="career_application.email"
                          :href="`mailto:${career_application.email}`"
                          >{{ career_application.email }}</a
                        >
                      </td>
                      <td>
                        <a
                          v-if="career_application.phone"
                          :href="`tel:${career_application.phone}`"
                          >{{ career_application.phone }}</a
                        >
                      </td>
                      <td>{{ career_application.city || "" }}</td>
                      <td>{{ career_application.position || "" }}</td>
                      <td>{{ career_application.experience || "" }}</td>
                      <td style="max-width: 260px">
                        <div
                          v-if="career_application.message"
                          class="message-clamp"
                          @click="showMessage(career_application.message)"
                        >
                          {{ career_application.message }}
                        </div>
                      </td>
                      <td>
                        <a
                          v-if="career_application.resume_url"
                          :href="career_application.resume_url"
                          target="_blank"
                          rel="noopener"
                          >Download</a
                        >
                        <span v-else>-</span>
                      </td>
                      <td style="min-width: 160px">
                        {{ formatDate(career_application.created_at) }}
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-else>
                    <tr>
                      <td colspan="100" class="text-center">No data found</td>
                    </tr>
                  </tbody>
                </template>
              </v-simple-table>
              <v-pagination rounded v-model="page" :length="paginationLength">
              </v-pagination>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog v-model="messageDialog" max-width="600">
        <v-card>
          <v-card-title class="text-h6">Message</v-card-title>
          <v-card-text style="white-space: pre-wrap">{{
            messageDialogText
          }}</v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text color="primary" @click="messageDialog = false"
              >Close</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-container>
  </v-main>
</template>

<script>
import axios from "axios";
export default {
  name: "CareerApplicationsPage",
  data() {
    return {
      filter: {
        search_keyword: "",
      },
      career_applications: [],
      page: 1,
      selectedRowsPerPage: 10,
      serialNoStarting: 0,
      paginationLength: 0,
      count: 0,
      isLoading: false,
      messageDialog: false,
      messageDialogText: "",
    };
  },
  watch: {
    page: "getData",
    $route() {
      this.getData();
    },
  },
  mounted() {
    this.getData();
  },
  methods: {
    showMessage(message) {
      this.messageDialogText = message;
      this.messageDialog = true;
    },
    formatDate(value) {
      if (!value) return "";
      try {
        const d = new Date(value);
        return d.toLocaleString();
      } catch (e) {
        return value;
      }
    },
    async getData() {
      this.isLoading = true;
      this.filter.search_keyword = this.filter.search_keyword
        ? this.filter.search_keyword
        : "";
      const query =
        "page=" +
        this.page +
        "&rowsPerPage=" +
        this.selectedRowsPerPage +
        "&search_keyword=" +
        this.filter.search_keyword;
      await axios
        .get(`career_applications?${query}`)
        .then((response) => {
          this.career_applications = response.data.data;
          this.count = response.data.count;
          this.serialNoStarting = (this.page - 1) * this.selectedRowsPerPage;
          this.paginationLength = Math.ceil(this.count / this.selectedRowsPerPage);
        })
        .catch(function (error) {
          console.log(error);
        });
      this.isLoading = false;
    },
  },
};
</script>

<style scoped>
.message-clamp {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
  cursor: pointer;
  max-width: 260px;
}
</style>
